import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import cn from "classnames";
import { getRange, getWeeks } from "redux/selectors/dashboardSelector";
import { setWeeks, setRange } from "redux/reducers/dashboardReducer";
import DropDownMenu from "app/components/DropDownMenu";

import CustomRange from "./CustomRange";
import moment from "moment-timezone";
import { useGetUser } from "redux/hooks";
import { STATES_LIST, COUNTRY_LIST } from "shared/constants";

const dropDownMenuData = [
  { label: "7 Days", value: 1 },
  { label: "30 Days", value: 4 },
  { label: "3 Months", value: 12 },
  { label: "4 Months", value: 16 },
  { label: "6 Months", value: 24 },
  { label: "12 Months", value: 48 },
];

const customItem = { label: "Custom Range", value: 0 };

const DateSelector = ({
  withCustomDates,
  country,
  setCountry,
  state,
  setState,
}) => {
  const dispatch = useDispatch();
  const { isCorporateUser } = useGetUser();

  const weeks = useSelector(getWeeks);
  const [showCustomRange, setShowCustomRange] = useState(false);
  const customRangeDates = useSelector(getRange);

  useEffect(() => {
    return () => {
      dispatch(
        setRange({
          start: null,
          end: null,
        }),
      );
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const menuItemHandler = ({ index }) => {
    const newValue = dropDownMenuData[index]?.value;
    if (newValue) {
      dispatch(setWeeks(newValue));
      dispatch(
        setRange({
          start: null,
          end: null,
        }),
      );
      setShowCustomRange(false);
    } else {
      dispatch(
        setRange({
          start: moment().format("YYYY-MM-DD"),
          end: moment().format("YYYY-MM-DD"),
        }),
      );
      setShowCustomRange(true);
    }
  };

  const countryHandler = ({ index }) => {
    const newValue = COUNTRY_LIST[index]?.value;
    if (newValue) {
      setCountry(newValue);
      setState(null);
    }
  };

  const stateHandler = ({ index }) => {
    const newValue = STATES_LIST[index]?.value;
    if (newValue) {
      setState(newValue);
    } else {
      setState(null);
    }
  };

  const updateRange = val => {
    dispatch(setRange(val));
  };

  const dataList = withCustomDates
    ? [...dropDownMenuData, customItem]
    : dropDownMenuData;

  const showFilter = isCorporateUser && !!setCountry;

  return (
    <div className="d-flex">
      {showFilter && (
        <div className="select-wrapper">
          <span className="select-title">Country</span>
          <DropDownMenu
            data={COUNTRY_LIST}
            initialIndex={country === "au" ? 0 : 1}
            itemHandler={countryHandler}
            className="select-menu"
          />
        </div>
      )}
      <div style={{ width: "12px" }}></div>
      {showFilter && country === "au" && (
        <div className="select-wrapper">
          <span className="select-title">State</span>
          <DropDownMenu
            data={[{ label: "All", value: null }, ...STATES_LIST]}
            initialIndex={
              state ? STATES_LIST.findIndex(s => s.value === state) : 0
            }
            itemHandler={stateHandler}
            className="select-menu"
          />
        </div>
      )}
      <div style={{ width: "12px" }}></div>
      <div className="select-wrapper">
        <span className="select-title">Showing last</span>
        <DropDownMenu
          data={dataList}
          initialIndex={dataList.findIndex(item => item.value === weeks)}
          itemHandler={menuItemHandler}
          className={cn("select-menu", { "w-130px": withCustomDates })}
        />
      </div>
      {showCustomRange && (
        <CustomRange dates={customRangeDates} onChange={updateRange} />
      )}
    </div>
  );
};

export default DateSelector;
